import { BootstrapVue, IconsPlugin, OverlayPlugin } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";
import es from "vee-validate/dist/locale/es.json";
import * as rules from "vee-validate/dist/rules";
import Vue from "vue";
import App from "./App.vue";
import responseInterceptor from "./interceptors/axiosInterceptor";
import router from "./router";
import store from "./store";

// Import Bootstrap an BootstrapVue CSS files (order is important)

import "./custom.css";
import "./main.scss";

import moment from "moment";

//import "bootstrap/dist/css/bootstrap.css";
//import "bootstrap-vue/dist/bootstrap-vue.css";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// OverlayPlugin
Vue.use(OverlayPlugin);

// Vee Validation
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

// Agregado de rules para password
extend("NonAlphanumeric", {
  message: (field) => "El campo " + field + " requiere un cáracter no alfa númerico. ",
  validate: (value) => {
    const specialChars = /[`!@#$%^&*()_+\-={};':|,.<>?~]/;
    return specialChars.test(value);
  },
});

extend("Lower", {
  message: (field) => "El campo " + field + " requiere una letra minúscula. ",
  validate: (value) => /[a-z]/.test(value),
});

extend("Upper", {
  message: (field) => "El campo " + field + " requiere una letra mayúscula. ",
  validate: (value) => /[A-Z]/.test(value),
});

extend("Digit", {
  message: (field) => "El campo " + field + " requiere solo números ",
  validate: (value) => /[0-9]/.test(value),
});

extend("DigitPassword", {
  message: (field) => "El campo " + field + " requiere un número ",
  validate: (value) => /[0-9]/.test(value),
});

extend("MMDDYYYY", {
  message: "El campo debe ser una fecha valida. ",
  validate: (value) => value == "" || /(0[1-9]|1[0-2])(\/)([0-2][0-9]|3[0-1])\2(\d{4})/.test(value),
});

extend('date_min', {
  params: ['min', 'format'],
  validate(value, { min, format }) {
    if (!value) return true;
    const parsed = moment(value, 'YYYY-MM-DD', true);
    const minDate = min === 'today'
    ? moment().startOf('day')
    : moment(min, format, true);
    return parsed.isValid() && !parsed.isBefore(minDate);
  },
  message: (field, { min }) => {
    const label = min === 'today' ? 'hoy' : min;
    return `El campo ${field} no puede ser anterior a ${label}`;
  }
});

extend('date_max', {
  params: ['max', 'format'],
  validate(value, { max, format }) {
    if (!value) return true;
    const parsed = moment(value, format, true);

    const maxDate = max === 'today'
      ? moment().startOf('day')
      : max === 'today+9m'
      ? moment().add(9, 'months').startOf('day')
      : moment(max, 'YYYY-MM-DD');

    return parsed.isValid() && !parsed.isAfter(maxDate);
  },
  message(field, { max }) {
    const label = max === 'today' ? 'hoy' : max === 'today+9m' ? '9 meses desde hoy' : max;
    return `El campo ${field} no puede ser posterior a ${label}`;
  }
});


extend('date_format', {
  params: ['format'],
  validate(value, { format }) {
    if (!value) return true;
    return moment(value, format, true).isValid(); // true = strict mode
  },
  message: (field, { format }) => `El campo ${field} debe tener el formato ${format}`
});

localize("es", es);

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.config.productionTip = false;

document.documentElement.style.setProperty("--primary", "#ad8430");
document.documentElement.style.setProperty("--secondary", "#2a2c2e");

responseInterceptor(router, store);

initVue();

function initVue() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
